module.exports = __webpack_public_path__ + "static/media/ketoemagtramina-3.69af29f8.png";